import React from "react"
import { PCViewRoot } from "./PCViewContext"
import { FilterConditionsRoot } from "./FilterConditionsContext"

export const Root = (props) => {
  return (
    <FilterConditionsRoot>
      <PCViewRoot>{props.children}</PCViewRoot>
    </FilterConditionsRoot>
  )
}
